var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-tooltip"},[_c('span',{ref:"linkRef",staticClass:"tooltip-value",domProps:{"innerHTML":_vm._s(_vm.highlight())}})])
}
var staticRenderFns = []

export { render, staticRenderFns }